<ng-template #checkboxLabel>
    <ng-content></ng-content>
</ng-template>

<ng-template #checkboxSupportingText>
    <ng-content select="[checkboxSupportingText]"></ng-content>
</ng-template>